module.exports = {
      id: "mail-line-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.56e2db0a.svg#mail-line-usage",
      toString: function () {
        return this.url;
      }
    }